/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './metadataCompare.tpl.html';
import './metadataCompareProgress.tpl.html';
import './metadataComponentsView/metadataComponents.js';
import './resultsView/results.js';
import './selectView/selectview.js';

angular
  .module('metadataCompare', [
    'ui.router',
    'metadataCompare.select',
    'metadataCompare.metadataComponents',
    'metadataCompare.results',
    'services.view',
    'shared.confirmModal',
    'services.util'
  ])
  // This defines the main abstract metadata compare view that is shared across all
  // subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      // This view is shared between multiple states
      var metadataCompareProgress = {
        templateUrl: 'metadataCompare/metadataCompareProgress.tpl.html',
        controller: 'SharedProgressCtrl'
      };

      $stateProvider
        .state(VIEW_STATES.METADATA_COMPARE, {
          abstract: true,
          views: {
            content: {
              templateUrl: 'metadataCompare/metadataCompare.tpl.html',
              controller: 'MetadataCompareCtrl'
            }
          }
        })
        // The views that are rendered in the select view.
        .state(VIEW_STATES.METADATA_COMPARE_SELECT, {
          url: '/metadataCompare/selectview/:compareAgainst/:differentDestinationSfId/:differentDestinationName/:batchPickerStoreLeftBatchId/:batchPickerStoreRightBatchId/:compareAgainstSameOrgBatch',
          resolve: {
            batchPickers: [
              '$stateParams',
              '$q',
              'BasicBatchPickerStore',
              function ($stateParams, $q, BasicBatchPickerStore) {
                var batchPickerStoreLeft = new BasicBatchPickerStore(),
                  batchPickerStoreRight = new BasicBatchPickerStore(),
                  leftBatchId,
                  rightBatchId,
                  getLeftBatchPromise,
                  getRightBatchPromise;

                // get batches. If we are coming from the component selection state,
                // we should have stateParams set to remember the previous state user was in.
                if ($stateParams.batchPickerStoreLeftBatchId) {
                  leftBatchId = parseInt($stateParams.batchPickerStoreLeftBatchId);
                  getLeftBatchPromise = batchPickerStoreLeft.getBatch(leftBatchId);
                } else {
                  getLeftBatchPromise = batchPickerStoreLeft.getLatest();
                }

                if ($stateParams.batchPickerStoreRightBatchId) {
                  rightBatchId = parseInt($stateParams.batchPickerStoreRightBatchId);
                  getRightBatchPromise = batchPickerStoreRight.getBatch(rightBatchId);
                } else {
                  getRightBatchPromise = batchPickerStoreRight.getLatest();
                }

                return $q.all([getLeftBatchPromise, getRightBatchPromise]).then(function () {
                  // finally resolve the entire batch picker objs
                  return [batchPickerStoreLeft, batchPickerStoreRight];
                });
              }
            ]
          },
          views: {
            wizardContent: {
              templateUrl: 'metadataCompare/selectView/selectview.tpl.html',
              controller: 'MetadataCompareSelectViewCtrl'
            },
            metadataCompareProgress: metadataCompareProgress
          }
        })
        // The views that are rendered in the select view.
        .state(VIEW_STATES.METADATA_COMPARE_SELECT_COMP_TYPES, {
          url: '/metadataCompare/selectComponentTypes/:compareAgainst/:differentDestinationSfId/:differentDestinationName/:batchPickerStoreLeftBatchId/:batchPickerStoreRightBatchId/:compareAgainstSameOrgBatch',
          resolve: {
            orgInfo: [
              'accountUtils',
              function (accountUtils) {
                return accountUtils.getOrgInfo();
              }
            ],
            metadataComponents: [
              '$stateParams',
              'httpBatch',
              function ($stateParams, httpBatch) {
                var leftBatchId = parseInt($stateParams.batchPickerStoreLeftBatchId);

                if (!leftBatchId) {
                  return Promise.resolve(null);
                }

                return httpBatch.getBatch(leftBatchId).then(function (batch) {
                  var metaDataTypesObj = {};

                  // Add the key (name) of the counts to the object to be used in ui
                  _.each(batch.metadataTypeCounts, function (counts, type) {
                    metaDataTypesObj[type] = _.clone(counts);
                    // save the name as part of the object
                    metaDataTypesObj[type].name = type;
                  });

                  return metaDataTypesObj;
                });
              }
            ]
          },
          views: {
            wizardContent: {
              templateUrl: 'metadataCompare/metadataComponentsView/metadataComponents.tpl.html',
              controller: 'MetadataComponentsViewCtrl'
            },
            metadataCompareProgress: metadataCompareProgress
          }
        })
        // The views that are rendered in the results view.
        .state(VIEW_STATES.METADATA_COMPARE_RESULTS, {
          url: '/metadataCompare/resultsview/:batchId',
          views: {
            resultsContent: {
              templateUrl: 'metadataCompare/resultsView/results.tpl.html',
              controller: 'MetadataCompareResultsViewCtrl'
            },
            metadataCompareProgress: metadataCompareProgress
          }
        });
    }
  ])
  /**
   * Controller for the metadata compare view.
   */
  .controller('MetadataCompareCtrl', [
    '$rootScope',
    '$scope',
    '$state',
    'httpBatch',
    'progressFactory',
    'WizardService',
    'VIEW_STATES',
    'batchUtils',
    function ($rootScope, $scope, $state, httpBatch, progressFactory, WizardService, VIEW_STATES, batchUtils) {
      $scope.resultsView = $state.current.name === VIEW_STATES.METADATA_COMPARE_RESULTS;

      // When the user initiates the compare we'll give them the option to stay on this page and wait or go to the
      // dashboard. This mask provides these options when shown. metadataComponents.js turns the mask on and off.
      // If there is already a compare running we'll show this mask from the start.
      $rootScope.showMaskWithDashboardButton = progressFactory.metadataCompareInProgress;

      // The wizard is not shown in the results view
      if (!$scope.resultsView) {
        // Reset the WizardService so we start fresh each time
        WizardService.reset();

        // Initialize the wizard
        WizardService.setStatePrefix(VIEW_STATES.METADATA_COMPARE + '.');
        WizardService.setNextState(getNextState);
        WizardService.setStepKeys(['SELECT_ORG', 'SELECT_METADATA']);
        WizardService.setInitialState(VIEW_STATES.METADATA_COMPARE_SELECT);
        WizardService.setCancelConfirmTextKey('CONFIRM_COMPARE_EXIT');
      }

      // When we start a compare we show a mask on the screen. Watch for the compare to finish so we can remove the mask.
      $scope.$watch(
        function () {
          return progressFactory.metadataCompareInProgress;
        },
        function (newValue, oldValue) {
          if (oldValue === true && newValue === false) {
            // A compare finished. We now want to go to the metadata compare results page and we'll need the batch id
            // for that. Ideally, we'd use the current user id to know which progress data to look at and get the batch
            // id from the progress data.
            httpBatch
              .getLatestMetadataCompare()
              .then(function (batch) {
                // We can hide the mask now.
                batchUtils.loadBatch(batch.batchId).then(() => {
                  $rootScope.showMaskWithDashboardButton = false;
                  $state.go(VIEW_STATES.METADATA_COMPARE_RESULTS, { batchId: batch.batchId }, { reload: true });
                });
              })
              .catch(function () {
                // We couldn't get the batch. We'll punt and go to the dashboard.
                $rootScope.showMaskWithDashboardButton = false;
                $state.go(VIEW_STATES.ADMIN_HOME);
              });
          } else if (oldValue === false && newValue === true) {
            // Show the dashboard mask when a compare starts
            $rootScope.showMaskWithDashboardButton = true;
          }
        }
      );

      /**
       * Determines the state that comes after the current state, based on the current settings.
       *
       * @returns {string} the name of the state corresponding to the next page.
       */
      function getNextState() {
        var currentState = WizardService.getCurrentState();
        var nextState;

        switch (currentState) {
          case VIEW_STATES.METADATA_COMPARE_SELECT:
            nextState = VIEW_STATES.METADATA_COMPARE_SELECT_COMP_TYPES;
            break;

          case VIEW_STATES.METADATA_COMPARE_SELECT_COMP_TYPES:
            nextState = VIEW_STATES.METADATA_COMPARE_RESULTS;
            break;

          default:
            break;
        }

        return nextState;
      }
    }
  ]);
